import {createContext} from 'react'

const CatTipoInterconsultaContext = createContext()

export default CatTipoInterconsultaContext